import React from "react";
import SupportLayout from "../support/SupportLayout";
import AdminSalesContent from "./components/AdminSalesContent";

const AdminSales = () => {
  return (
    <SupportLayout userRole="ADMIN">
      <AdminSalesContent useOwnLayout={true} />
    </SupportLayout>
  );
};

export default AdminSales;
